import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=8453cc1c"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8453cc1c')) {
      api.createRecord('8453cc1c', component.options)
    } else {
      api.reload('8453cc1c', component.options)
    }
    module.hot.accept("./BaseInput.vue?vue&type=template&id=8453cc1c", function () {
      api.rerender('8453cc1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BaseInput.vue"
export default component.exports